import { colors } from './colors';
import { gradients } from './gradients';

export const UI_STYLES = {
  // Градиенты
  ...gradients,
  colors,
  
  // Цвета текста
  emeraldTextColor: "text-emerald",
  emeraldBorderColor: "border-emerald",
  emeraldBorderColorFocus: "focus:border-emerald",
  
  // Цвета фона
  bgDarkBlue: "bg-darkBlue",
  bgDarkBlueHover: "hover:bg-darkBlue4/70",
  bgDarkBlue2: "bg-darkBlue2", 
  bgDarkBlue4: "bg-darkBlue4",
  bgEmerald: "bg-emerald",
}; 
